module.exports = __webpack_public_path__ + "static/media/Qatar.05769c9f.jpg";